import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MobilePanelNav({
  children,
  title
}) {
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-field-default",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h3",
        paddingInline: "600",
        paddingBlock: "200",
        typography: "heading-50",
        children: title
      })
    }), children]
  });
}